import { Attr } from "spraypaint";
import ApplicationRecord from "./ApplicationRecord";

class ApplicationAction extends ApplicationRecord {
  static jsonapiType = "application_actions";

  @Attr() authorId: string;

  @Attr() action: string;
}

export default ApplicationAction;
